import React from 'react';
import { Container as BootstrapContainer } from 'react-bootstrap';
import clsx from 'clsx';

export interface ContainerProps {
  fluid?: boolean;
  className?: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

const Container: React.FC<ContainerProps> = ({
  fluid = false,
  className,
  children,
  maxWidth,
  ...props
}) => {
  const containerClass = clsx(
    className,
    maxWidth && `container-${maxWidth}`
  );

  return (
    <BootstrapContainer
      fluid={fluid}
      className={containerClass}
      {...props}
    >
      {children}
    </BootstrapContainer>
  );
};

export default Container;